import { render, staticRenderFns } from "./workspace-library-risk-weakness-definition-form.vue?vue&type=template&id=65b2cbd0&"
import script from "./workspace-library-risk-weakness-definition-form.vue?vue&type=script&lang=js&"
export * from "./workspace-library-risk-weakness-definition-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports